import { uploadPurgePath } from "./product_draft.mjs"

// Purga una subida por DirectUpload que ya no viaja en ningún form; nunca lanza.
// Doc: _docs/features/products/product_wizard_draft.md
export function purgeUpload(signedId) {
  const token = document.querySelector("meta[name='csrf-token']")?.content || ""
  return fetch(uploadPurgePath(signedId), { method: "DELETE", headers: { "X-CSRF-Token": token } }).catch(() => {})
}
